import React from 'react';
import { Users, Sparkles, TrendingUp, Globe } from 'lucide-react';

const values = [
  { icon: Users, title: 'Empower Our People' },
  { icon: Sparkles, title: 'Innovate Daily' },
  { icon: TrendingUp, title: 'Build Wealth' },
  { icon: Globe, title: 'Impact Generations' },
];

const Mission = () => {
  return (
    <section id="mission" className="relative py-20">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="max-w-[720px] mx-auto text-center">
          {/* Content */}
          <div>
            <div className="text-[12px] font-semibold tracking-[0.3em] mb-4">
              <span className="bg-gradient-to-r from-[#a855f7] to-[#60a5fa] bg-clip-text text-transparent">
                OUR MISSION
              </span>
            </div>
            <h2 className="text-white text-[36px] lg:text-[44px] font-bold tracking-tight leading-[1.1]">
              <span className="bg-gradient-to-r from-white via-[#e9d5ff] to-[#c084fc] bg-clip-text text-transparent">
                Black Owned.
              </span>
              <br />
              <span className="bg-gradient-to-r from-[#c084fc] via-[#a855f7] to-[#7c3aed] bg-clip-text text-transparent">
                Tech Driven.
              </span>
            </h2>
            <p className="text-gray-400 text-[15px] leading-relaxed mt-5 max-w-[560px] mx-auto">
              BLKPixel Technologies is a Black-owned technology company building innovative solutions that solve real problems, create opportunities, and help shape the future of technology.
            </p>
            <p className="text-gray-300 text-[15px] italic mt-4 leading-relaxed max-w-[560px] mx-auto">
              Build innovative technology. Empower entrepreneurs. Create ownership. Build wealth. Impact generations.
            </p>

            <div className="grid grid-cols-2 gap-3 mt-7 max-w-[520px] mx-auto">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="flex items-center gap-3 p-3 rounded-lg bg-white/5 border border-white/5 hover:border-[#a855f7]/40 transition-colors"
                >
                  <div className="w-9 h-9 rounded-md bg-gradient-to-br from-[#7c3aed]/30 to-[#4f46e5]/20 border border-[#a855f7]/30 flex items-center justify-center flex-shrink-0">
                    <v.icon className="w-4 h-4 text-[#c084fc]" />
                  </div>
                  <div className="text-white text-[13px] font-medium">{v.title}</div>
                </div>
              ))}
            </div>

            <div className="mt-7 pt-5 border-t border-white/5 max-w-[560px] mx-auto">
              <div className="text-white font-semibold text-[15px]">Built by us. Built for all.</div>
              <p className="text-gray-400 text-[13px] mt-1.5">
                BLKPixel welcomes businesses, founders, organizations, agencies, and entrepreneurs from every background.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
